const howWeHirePage = (gsap, mm, ScrollTrigger, Pagination, smoother) => {
  
  /***************************************************************
    PARALLAX ITEMS
  ***************************************************************/
 
    
    // step functionality
    mm.add("(max-width: 991px)", () => {
      $(".step").not('.open').find('.step-details').slideUp();

      return () => {
        $(".step .step-details").attr('style', '');
      }
    }, '.page-how-we-hire');

    if ($(".steps").length != 0) {
        $(".step").on("mouseenter click", function () {
            var el = $(this);
            if (!el.hasClass("open")) {
                $(".step").removeClass("open");
                el.addClass("open");
                openStepMobile(el);
            }
        });
    }

    function openStepMobile(el) {
      if ($(window).width() > 991)
        return;

      $(".step").not(el).find('.step-details').slideUp();
      el.find('.step-details').slideDown();
    }


    /***************************************************************
      INTERVIEW PROCESS BLOCK
    ***************************************************************/


    const numPhases = $('.timeline-cards .card-container').length - 0.001;
    let timePhase = 0;

  // Wrap the current ScrollTrigger in mm call to keep it from happening on mobile
  mm.add("(min-width: 768px)", () => {
    ScrollTrigger.create({
      trigger: $('.hwh-timeline-container'),
      pin: $('.hwh-timeline-container'),
      start: "center center",
      end: "500%", // Change value to effect scroll length
      onUpdate: ({progress}) => {
        checkInterviewPhase(progress);
      }
    });
  }, '.page-how-we-hire');



    // Setup Process Slides
    const maxPhases = $('.timeline-cards .card-container').length;
    let curPhase = 0;

    // Adjust pagination text
    $('.timeline-phases .phase-pagination')[0].innerHTML = 
    `${curPhase + 1} / ${maxPhases}`;
  

    // Clicking Prev
    $('.timeline-phases .phase-nav .phase-prev').on('click', () => {
      changePhase(-1);
    });
  
    // Clicking Next
    $('.timeline-phases .phase-nav .phase-next').on('click', () => {
      changePhase(1);
    });

    function changePhase(progress) {
      var curActive = $('.timeline-cards .card-container.active');
      var index = curActive.index();
      var next = index + progress;
      curPhase = next;

      if ((progress < 0) && (next >= 0)) {
        curActive.removeClass('active').prev().addClass('active');
        $(".timeline-phases .timeline-phase.active").removeClass('active').prev().addClass('active');

        $('.timeline-phases .phase-pagination')[0].innerHTML = 
        `${curPhase + 1} / ${maxPhases}`;
    
      }
      else if ((progress > 0) && (next < maxPhases)) {
        curActive.removeClass('active').next().addClass('active');
        $(".timeline-phases .timeline-phase.active").removeClass('active').next().addClass('active');

        $('.timeline-phases .phase-pagination')[0].innerHTML = 
        `${curPhase + 1} / ${maxPhases}`;
      }

      if (next === 2) {
        $(".timeline-cards .card-container:first-child").css('z-index', '2');
      }
      else {
        if (next < maxPhases) {
          $(".timeline-cards .card-container:first-child").css('z-index', '6');
        }
      }
    }




    $('.path-intro a').addEventListener("click", (event) => {
      // Prevent the default action
      event.preventDefault();
      let target = event.target;
      let hash = target.hash;
  
      gsap.to(window, {
        duration: 1,
        scrollTo: hash,
        ease: "Power1.easeInOut"
      });
    });

    $('.timeline-phase a').addEventListener("click", (event) => {
      // Prevent the default action
      event.preventDefault();
      let target = event.target;
      let hash = target.hash;
  
      gsap.to(window, {
        duration: 1,
        scrollTo: hash,
        ease: "Power1.easeInOut"
      });
    });

    // Checks which phase should be showing in the process
    function checkInterviewPhase(progress) {
      const newPhase = Math.floor(progress * numPhases);

      // Phase Transformation values
      const phase1Trans = gsap.utils.clamp(0, 0.3, progress - 0.3) / 0.3 * -80;
      const phase2TransPer = 
        (gsap.utils.clamp(0, 0.05, progress - 0.3) / 0.05 * -50);
      const phase2Trans = gsap.utils.clamp(0, 0.3, progress - 0.63) / 0.3 * -80;
      const phase3TransPer = 
        (gsap.utils.clamp(0, 0.05, progress - 0.3) / 0.05 * -50) + 
        (gsap.utils.clamp(0, 0.05, progress - 0.63) / 0.05 * -50);

      // Transform phases
      gsap.to($($('.card-container')[0]), {
        y: phase1Trans + "vh", 
        duration: 0
      });
      gsap.to($($('.card-container')[1]), {
        y: phase2Trans + "vh",
        yPercent: phase2TransPer, 
        duration: 0
      });
      gsap.to($($('.card-container')[2]), {
        yPercent: phase3TransPer, 
        duration: 0
      });

      if (newPhase !== timePhase) {
        timePhase = newPhase;
        $($('.card-container').addClass('active')[newPhase]).find("~ .card-container").removeClass('active');
        $(".timeline-phases .timeline-phase.active").removeClass('active');
        $($('.timeline-phases .timeline-phase')[newPhase]).addClass('active');
      }
    }

  
    /***************************************************************
      HIRING BLOCK
    ***************************************************************/
   
    openPositions(gsap);
      
  }
  
  export {
    howWeHirePage
  };
  
